import type { PaymentChannel } from 'interfaces';

const BULLET_SYMBOL = '\u2022';

export const formattedMaskedBankNumberArray = (number: string, type: PaymentChannel, symbol = BULLET_SYMBOL) => {
  if (type === 'card') {
    const formatted = number
      .replace(/X/g, symbol)
      .replace(/(.{1,4})/g, '$1 ')
      .trim();
    return Array.from(formatted);
  } else {
    const slicedNumber = [...number.slice(-4)];
    const bullets = symbol.repeat(4);
    const maskedNumber: string[] = [...bullets, ' ', ...slicedNumber];
    return maskedNumber;
  }
};

export const formattedMaskedBankNumber = (number: string, type: PaymentChannel, symbol = BULLET_SYMBOL) => {
  if (!number) {
    return '';
  }
  return formattedMaskedBankNumberArray(number, type, symbol).join('');
};
